// extracted by mini-css-extract-plugin
module.exports = {"customerLogo":"Auth_customerLogo__2gRw7","container":"Auth_container__C-3wH"};